import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'
import { Link } from 'react-router-dom'

const Photo = () => {
  return (
    <>
      <Bredcrumb title="Photo Gallery" />
      <section className="facility-box mt-4">
        <div className="container">
          {/* <div className="row">
            <div className="col-8 mx-auto center-col margin-50px-bottom sm-margin-40px-bottom text-center">
              <h3 className="font-weight-500 font-size32 md-font-size28 sm-font-size26 xs-font-size24 section-title">Photo Gallery</h3>
              <div className="title-border"><span className="lg"></span><span className="md"></span><span className="sm"></span></div>
            </div>
          </div> */}
          <div className="row mb-4">
				        <div className="col-md-12">
					          <div className="gallery text-center row">
                        <div className="col-lg-4 col-md-6 items presentation margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1802.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1802.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 items courses margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1817.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1817.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1865.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1865.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1916.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1916.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1930.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1930.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1971.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1971.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
						            <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_1981.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_1981.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
						            <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_6156.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_6156.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
						            <div className="col-lg-4 col-md-6 items books margin-30px-bottom sm-margin-25px-bottom xs-margin-20px-bottom">
                            <div className="gallary-block">
                                <div className="position-relative">
                                    <img src="img/gallery/DSC_6164.png" alt="" />
                                    <div className="overlay-box">
                                        <Link href="img/gallery/DSC_6164.png" className="popimg"><i className="fas fa-plus"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
              </div>
            </div>	           
          </div>
        </section>
    </>
  )
}

export default Photo
